
const styles = {
        Sign_In_button: {
            'margin-left': '55px',
            'margin-top': '10px',
        },
        user_SignIn: {
            'margin-bottom': '10px',
        }
    }
    
    
    export default styles;